// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"61133e77","581":"e748a845","777":"e79097b6"}[chunkId] + ".chunk.js";
};